module.exports = __webpack_public_path__ + "assets/a9fc11fb17cd5a4945ea231d967c07cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/channels/hu/2.png
// module id = 340
// module chunks = 1